export const TEXT_GRADE_MAP: Record<number, string> = {
  5: 'Hervorragend',
  4: 'Sehr gut',
  3: 'Gut',
  2: 'Befriedigend',
  1: 'Ausbaufähig',
};

export const TRUSTED_SHOPS_FEEDBACK_URL = 'https://www.trustedshops.de/bewertung/info_X465BF196A8B4C75EA753899D9F500E5B.html';
